<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Expanding your footprint in Africa?</h2>
    <p>
      Making business decisions is hard to do in opaque and dynamic
      markets.Connecting with companies even harder. Our suite of data-driven
      and digital solutions can help you identify, verify and engage with
      African companies.
    </p>
    <div class="action-wrap">
      <a
        @click="openLink"
        class="cta-button"
        :class="colorMode === 'light' ? 'medium-button' : ''"
        >See Solutions</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'commercial-broad',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openLink() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Commercial Broad Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Commercial Broad Block',
      })
      this.$router.push({ name: 'solutions-page' })
    },
  },
}
</script>
